<template>
  <v-toolbar
    dark
    color="primary"
  >
    <v-btn
      icon
      dark
      @click="onClose"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <v-toolbar-title>
      <v-icon>receipt_long</v-icon>
      {{ $translate('SHOPPING_LISTS_AND_SUBSCRIPTIONS') }}
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <!-- Button to create subscription / shopping list if subscription is enabled -->
    <v-menu
      v-if="showSubscibeBtn"
      bottom
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="white"
          dark
          fab
          small
          v-bind="attrs"
          v-on="on"
        >
          <v-icon color="primary">mdi-plus</v-icon>
        </v-btn>
      </template>

      <v-list>
        <!-- To create subscription -->
        <v-list-item @click="onTakeSubscription">
          <span v-html="$translate('TAKE_SUBSCRIPTION')"></span>
        </v-list-item>
        <!-- To create shopping list -->
        <v-list-item @click="onCreateList">
          {{ $translate('NEW_SHOPPING_LIST_TITLE') }}
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- Button to create new list if subscription is disabled -->
    <v-tooltip v-else bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="white"
          dark
          fab
          small
          v-bind="attrs"
          v-on="on"
          @click="onCreateList"
        >
          <v-icon color="primary">mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>{{ $translate('NEW_SHOPPING_LIST_TITLE') }}</span>
    </v-tooltip>
  </v-toolbar>
</template>

<script>
export default {
  name: 'ShoppingListsHeader',
  computed: {
    partnerGroupDetails() {
      return this.$store.getters['Account/partnerGroupDetails'];
    },
    showSubscibeBtn() {
      if (this.partnerGroupDetails != null && this.partnerGroupDetails.ShowSubscriptionButton) {
        return true;
      }

      return false;
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    onTakeSubscription() {
      this.$emit('take-subscription');
    },
    onCreateList() {
      this.$emit('create-list');
    },
  },
};
</script>
